import { view, site, readOnly, siteLocales, dialogs, history, saving } from '@yola/ws-sdk';
import publishing from 'src/js/modules/publishing';
import yolaDialogs from 'yola-editor/src/js/modules/dialogs';
import yolaPublishing from 'yola-editor/src/js/modules/publishing';
import yolaSite from 'yola-editor/src/js/modules/site';
import dialogTypes from 'src/js/modules/dialogs/constants/dialog-types';
import customUiActionTypes from 'src/js/modules/custom-ui/constants/action-types';
import showReadOnlyModeDialog from '../helpers/show-read-only-mode-dialog';
import constants from '../constants';

const readOnlyManager = (store) => (next) => (action) => {
  const state = store.getState();
  const readOnlyStatus = readOnly.selectors.getReadOnlyStatus(state);
  if (!readOnlyStatus) {
    next(action);
    return;
  }

  // Prevent showing any dialogs if  read-only alert dialog is shown
  // It can be closed only by user action in the dialog
  if (action.type === dialogs.actionTypes.SHOW_DIALOG) {
    const activeDialog = dialogs.selectors.getDialog(state);
    if (activeDialog.type === dialogTypes.READ_ONLY_ALERT_DIALOG) {
      return;
    }
  }

  // Prevent hiding read-only alert dialog from other places except the dialog itself
  if (action.type === dialogs.actionTypes.HIDE_DIALOG) {
    const activeDialog = dialogs.selectors.getDialog(state);
    if (activeDialog.type !== dialogTypes.READ_ONLY_ALERT_DIALOG) {
      next(action);
      return;
    }
    if (action.payload.modalProps && action.payload.modalProps[constants.READONLY_SYMBOL]) {
      next(action);
    }

    return;
  }

  switch (action.type) {
    case customUiActionTypes.SHOW:
    case history.actionTypes.UNDO:
    case history.actionTypes.REDO:
    case siteLocales.actionTypes.ADD_LOCALE:
    case siteLocales.actionTypes.REMOVE_LOCALE:
    case siteLocales.actionTypes.SAVE_MAIN_LOCALE:
    case site.actionTypes.COPY_PAGE:
    case site.actionTypes.CREATE_PAGE:
    case site.actionTypes.CHANGE_PAGES_ORDER:
    case site.actionTypes.DELETE_PAGE:
    case site.actionTypes.ADD_FOLDER:
    case site.actionTypes.DELETE_FOLDER:
    case site.actionTypes.RENAME_FOLDER:
    case site.actionTypes.MOVE_TO_FOLDER:
    case site.actionTypes.SET_HOME_PAGE:
    case site.actionTypes.SET_CLEAN_URL_ENABLED:
    case site.actionTypes.UPDATE_SETTINGS:
    case site.actionTypes.UPDATE_INTEGRATIONS:
    case site.actionTypes.UPDATE_REDIRECTS:
    case site.actionTypes.UPDATE_PAGE_SETTINGS:
    case publishing.actionTypes.INITIATE_PUBLISH_WEBSITE:
    case yolaPublishing.actionTypes.UNPUBLISH_WEBSITE:
    case yolaSite.actionTypes.SITE_RESET:
    case view.actionTypes.SET_ELEMENT_ATTRIBUTE:
    case view.actionTypes.REPLACE_ELEMENT:
    case view.actionTypes.BULK_SET_CHILDREN_PRESENCE:
    case view.actionTypes.CUT_ELEMENT:
    case view.actionTypes.DELETE_ELEMENT:
    case view.actionTypes.DUPLICATE_ELEMENT:
    case view.actionTypes.INSERT_BLOCK:
    case view.actionTypes.INSERT_ELEMENT:
    case view.actionTypes.PASTE_ELEMENT:
    case view.actionTypes.REMOVE_ELEMENT_ATTRIBUTE:
    case view.actionTypes.SET_INLINE_ELEMENT_STYLE:
    case view.actionTypes.SET_CHILDREN_PRESENCE:
    case view.actionTypes.SHIFT_ELEMENT:
    case view.actionTypes.BULK_VIEW_ACTIONS: {
      showReadOnlyModeDialog();
      break;
    }

    case view.actionTypes.SYNCHRONIZE_ELEMENT: {
      showReadOnlyModeDialog({ reloadOnCancel: true });
      break;
    }

    case yolaDialogs.actionTypes.SHOW_DIALOG: {
      const dialogType = action.payload.type;
      if (
        dialogType === yolaDialogs.dialogTypes.SITE_RESET ||
        dialogType === yolaDialogs.dialogTypes.SITE_RESET_AND_UNPUBLISH ||
        dialogType === yolaDialogs.dialogTypes.UNPUBLISH_CONFIRM_ACTION
      ) {
        showReadOnlyModeDialog();
        return;
      }

      next(action);
      break;
    }

    case dialogs.actionTypes.SHOW_DIALOG: {
      const dialogType = action.payload.type;
      if (dialogType === dialogTypes.ADD_PAGE_DIALOG) {
        showReadOnlyModeDialog();
        return;
      }

      next(action);
      break;
    }

    // Prevent changing saving status in read-only mode to avoid triggering save immediately after taking control
    // https://github.com/yola/production/issues/16217
    case saving.actionTypes.SET_STATUS: {
      break;
    }

    default:
      next(action);
  }
};

export default readOnlyManager;
